import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PlagiarismIcon(props: IconProps) {
    return <Icon {...props} iconKey={"plagiarism"}/>
}
